import HTTP from '@/utils/http'
import { actionDict } from '@/utils/locale'
import notification from '@/utils/notification'
import * as diff from '@/api/tender-addendums/diff'

function setToValue (obj, value, path) {
  let i = 0
  for (; i < path.length - 1; i += 1) {
    if (!obj[path[i]]) {
      obj[path[i]] = {}; // eslint-disable-line
    }
    obj = obj[path[i]]; // eslint-disable-line
  }
  obj[path[i]] = value; // eslint-disable-line
}

function strip (html) {
  const tmp = document.createElement('DIV')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

export function camelToRegular (string) {
  const content = ''.concat(string)
  return content.replace(/([A-Z])/g, ' $1').replace(/^./, str => (str.toUpperCase()))
}

function assembleAddendumRevision (diffRec) {
  const revision = {}
  if (diffRec.kind !== 'A') {
    revision.action = actionDict[diffRec.kind]
    revision.value = diffRec.rhs
  } else {
    revision.action = actionDict[diffRec.item.kind]
    revision.value = diffRec.item.rhs
  }
  if (diffRec.path.includes('scopeOfWorks')) {
    revision.value = strip(revision.value)
  }
  revision.object = diffRec.path.map(camelToRegular).join(', ')
  revision.path = diffRec.path
  return revision
}

async function getRevisions (revisions, tenderId) {
  const response = await HTTP.get(`/revisions/tenders/${tenderId}`)
  Object.assign(revisions, response.data.data)
}

export async function getRevisionByVersionNum (tenderId, version = -1) {
  const response = await HTTP.get(`/revisions/tenders/${tenderId}/versions/${version}`)
  return response.data.data
}

export async function getRevisionDocuments (tenderId, version = -1) {
  const response = await HTTP.get(`/revisions/tenders/${tenderId}/versions/${version}`)
  return response.data.data.documents
}

async function parseRevisions (generalRevision, revisions, tenderId) {
  if (revisions.length >= 1) {
    revisions[0].revisions.forEach(
      (rec) => {
        setToValue(generalRevision, rec, rec.path)
      },
    )
  }
  try {
    const ducuments = await getRevisionDocuments(tenderId)
    generalRevision.documents = ducuments || []; // eslint-disable-line
  } catch (err) {
    generalRevision.documents = []; // eslint-disable-line
  }
}

function parseAddendums (revisions) {
  return revisions.map(
    (rec) => {
      const addendum = {}
      addendum.version = rec.version
      addendum.revisions = rec.revisions.map(assembleAddendumRevision)
      return addendum
    },
  )
}

/**
 * Get tender revisions, parse to general attributes
 * mapping to source attrs
 *
 * @param {*} tenderId tender's unique id
 */
export async function getGeneralRevision (tenderId) {
  const lastDiff = {}
  const revisions = []
  await getRevisions(revisions, tenderId)
  await parseRevisions(lastDiff, revisions, tenderId)
  return { lastDiff, revisions }
}

/**
 * Get tender addendums
 *
 * @param {*} tenderId tender's unique id
 */
export async function getAddendums (tenderId) {
  const revisions = []
  let addendums = []
  await getRevisions(revisions, tenderId)
  addendums = parseAddendums(revisions)
  return [addendums, revisions]
}

/**
 * Fallback tender version
 */
export async function fallbackTender (tenderId) {
  try {
    const response = await HTTP.post(`/revisions/tenders/${tenderId}/fallback`)
    notification.handleResponseAlert(response)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function createRevision (tenderId) {
  try {
    await HTTP.post(`/revisions/tenders/${tenderId}`)
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getAllVersions (tenderId) {
  const response = await HTTP.get(`revisions/tenders/${tenderId}/versions`)
  const allVersions = response.data.data
  return allVersions
}

export async function diffAllVersions (tenderId) {
  const allVersions = await getAllVersions(tenderId)
  const addendumsSummary = []
  allVersions.reduce((newTender, oldTender) => {
    if (!newTender) {
      return oldTender
    }
    const diffTenderResult = diff.diffTenderFields(oldTender, newTender)
    addendumsSummary.push({
      version: newTender.version,
      oldVersion: oldTender.version,
      addendum: diffTenderResult,
      comment: oldTender.comment,
      commentUpdatedAt: oldTender.commentUpdatedAt,
      commentUpdatedBy: oldTender.commentUpdatedBy,
    })
    return oldTender
  }, null)
  return addendumsSummary
}

export const updateAddendumComment = async (tenderId, commentIndex, content) => {
  try {
    const res = await HTTP.post(`/revisions/tenders/${tenderId}/addendum-comment/${commentIndex}`, {
      content,
    })
    return res
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
